import { combineReducers } from "redux";
import loginReducer from "./login";

const allReducers = combineReducers({
  loginReducer,
});

export default allReducers;